export const BIKE_UPGRADE_OPTIONS_LIST = [
    'Exhaust',
    'Tail tidy',
    'Screen',
    'Lever',
    'Grips',
    'Heated',
    'Bung',
    'Carbon',
    'Top box',
    'Quick shift',
    'Bobbins',
    'Scot oiler',
    'Nav',
    'Fender',
    'Sissy bar',
    'Pillion',
    'Chrome',
    'Alarm',
    'Tracker',
    'Silencer',
    'Mud',
];


export const OTHER_CATEGORY_ID = '62f10b87a63a1be29fc4ead1';
export const EXHAUST_CATEGORY_ID = '62f10b4ca63a1be29fc4eac7';



// WEBPACK FOOTER //
// ./src/modules/Leads/constants/bikeUpgrades.js